import React, { useState, useEffect } from "react";
import { Table, Form, OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import ExportToExcel from "../components/ExportToExcel";
import Pagination from "../components/Pagination";
import SearchBar from "../components/SearchBar";
import Tooltip from "react-bootstrap/Tooltip";
import { Modal, Button } from 'react-bootstrap';

const FormTable = ({
  data,
  columns,
  defaultColumns,
  itemsPerPage,
  searchTerm,
  setSearchTerm,
  Path,
}) => {
  const [visibleColumns, setVisibleColumns] = useState(defaultColumns);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const toggleColumn = (columnName) => {
    setVisibleColumns({
      ...visibleColumns,
      [columnName]: !visibleColumns[columnName],
    });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);

  return (
    <div>
      <div className="d-flex container-fluid justify-content-lg-end justify-content-center mb-2 me-3 mt-1">
        <div className="col-lg-2 mb-3 mb-md-0 me-1">
          <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>
        <button className="me-1" id="excel-btn">
          <ExportToExcel data={filteredData} filename="tableData.xlsx" />
        </button>
        <div className="btn-group">
          <button
            type="button"
            className="dropdown-toggle skill-button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            id="excel-btn"
          >
            <i className="bi bi-list"></i>
          </button>

          <ul className="dropdown-menu p-2">
            <div className="row">
              <Form.Group>
                {Object.keys(visibleColumns).map((columnName) => (
                  <Form.Check
                    key={columnName}
                    type="checkbox"
                    id={`checkbox-${columnName}`}
                    label={columnName} //custom column name
                    checked={visibleColumns[columnName]}
                    onChange={() => toggleColumn(columnName)}
                  />
                ))}
              </Form.Group>
            </div>
          </ul>
        </div>
      </div>
      <div className="box-body table-responsive container-fluid">
        <Table striped bordered hover>
        <thead id="thcolor" className="text-center">
        <tr>
          <th rowSpan={2} className="align-middle">Employee</th>
          <th colSpan={2} className="text-center">Raw Score 1</th>
          <th colSpan={2} className="text-center">Raw Score 2</th>
          <th rowSpan={2} className="align-middle">Action</th>

        </tr>
        <tr>
          <th className="text-center">Employee</th>
          <th className="text-center">Reviewer</th>
          <th className="text-center">Employee</th>
          <th className="text-center">Reviewer</th>
        </tr>
      </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={10} className="text-center">
                  No matching records found
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr key={index}>
                  <td className="col-3">{item.Employee}</td>
                  <td className="text-center ">{item.MCQEmp}/{item.MCQTotal}</td>
                  <td className="text-center ">{item.MCQRew}/{item.MCQTotal}</td>
                  <td className="text-center ">{item.MSQEmp}/{item.MSQTotal}</td>
                  <td className="text-center ">{item.MSQRew}/{item.MSQTotal}</td>
                  <td className="action-col">
                      <Link to={`/pr-evaluation-report/${item.ID}`}>
                        <i className="bi bi-eye-fill icons"></i>
                      </Link>
                    </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
        <Modal show={showModal} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Modal title</Modal.Title>
          </Modal.Header>
          <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleClose}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="d-flex justify-content-end">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredData.length}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default FormTable;
